import './privacypol.css'
const PrivacyPol=()=>{
    return(
        <>
         {/* <h1 style={{paddingTop: "4pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "left"}}>Wareeg Privacy</h1> */}
        <p  className="extraspace" style={{paddingTop: "10pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify"}}>This Privacy Policy (&quot;Policy&quot;) outlines how Wareeg (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) collects, uses, and protects the personal information of users (&quot;Users&quot;) of our peer-to-peer marketplace platform (&quot;Platform&quot;) that facilitates experiencers (&quot;Guests&quot;) to book locals (&quot;Hosts&quot;) to host a private experience anytime, anywhere. This Policy is in compliance with the General Data Protection Regulation (&quot;GDPR&quot;) and the California Consumer Privacy Act (&quot;CCPA&quot;).</p>
        <h4 style={{paddingTop: "7pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "left",color:" rgb(65, 137, 221)",fontWeight:"600",fontSize:"20px",fontFamily:"Poppins"}} className="extraheading1">Information We Collect</h4>
        <p  className="extraspace" style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent:"0pt",lineHeight: "108%",textAlign: "left"}}>We collect<span style={{color:"#DB524E"}}>*</span> personal information when Users register an account or use the Platform, including:</p>
        <ul id="l1">
            <li data-list-text="">
                <p className="extraspace" style={{paddingTop: "8pt",paddingLeft: "12pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>Contact information: name, email address, phone number, and location</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace" style={{paddingTop: "1pt",paddingLeft: "12pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                to:"-2px",
                marginRight: "5px"}}></span>Personal information: SSN, ID, DOB, residential address, and availability</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace" style={{paddingTop: "1pt",paddingLeft: "12pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>Payment information: payment card details or direct deposit information</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace" style={{paddingTop: "1pt",paddingLeft: "12pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>Profile information: profile picture, interests, languages, hosting city, and bio</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace" style={{paddingTop: "1pt",paddingLeft: "12pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                postion:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>Communication information: any correspondence Users have with each other through the Platform</p>
                <p  className="extraspace" style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent:"0pt",lineHeight: "108%",textAlign: "left"}}>
                    <span style={{color:"#DB524E"}}>*</span>The information you will be asked to input during registration may vary depending on whether you are registering for a guest or host account/profile.
                </p>
                <h4 style={{paddingTop: "8pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify",color:" rgb(65, 137, 221)",fontWeight:"600",fontSize:"20px",fontFamily:"poppins"}}  className="extraheading1">How We Use Your Information</h4>
                <p className="extraspace" style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify"}}>We use personal information for the following purposes:</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace1" style={{paddingTop: "9pt",paddingLeft: "33pt",textIndent: "-18pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                postion:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>To provide and improve our Platform</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace1" style={{paddingTop: "1pt",paddingLeft: "33pt",textIndent: "-18pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>To verify User identity and prevent fraudulent activity</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace1" style={{paddingTop: "1pt",paddingLeft: "33pt",textIndent: "-18pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>To communicate with Users about their experiences and bookings</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace1" style={{paddingTop: "1pt",paddingLeft: "33pt",textIndent: "-18pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>To process payments, payouts and refunds</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace1" style={{paddingTop: "1pt",paddingLeft: "33pt",textIndent: "-18pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>To personalize User experience and match Users with compatible hosts or guests</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace1" style={{paddingTop: "1pt",paddingLeft: "33pt",textIndent: "-18pt",textAlign: "justify"}}><span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>To comply with legal obligations, including GDPR and CCPA</p>
                <p  className="extraspace" style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify"}}>We will not use your personal information for marketing purposes without your consent.</p>
                <h4  className="extraheading1" style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify",color:" rgb(65, 137, 221)",fontWeight:"600",fontSize:"20px",fontFamily:"Poppins"}}>Information Sharing</h4>
                <p  className="extraspace" style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify"}}>We may share personal information with the following third-party service providers:</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace" style={{paddingTop: "9pt",paddingLeft: "30pt",textIndent: "-18pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>Payment processing companies to process payments and payouts</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace" style={{paddingTop: "4pt",paddingLeft: "30pt",textIndent: "-18pt",textAlign: "justify"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>Hosting providers to host the Platform</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace" style={{paddingTop: "1pt",paddingLeft: "30pt",textIndent: "-18pt",textAlign: "left"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>Customer service providers to assist with user support</p>
            </li>
            <li data-list-text="">
                <p  className="extraspace" style={{paddingTop: "1pt",paddingLeft: "30pt",textIndent: "-18pt",textAlign: "left"}}> <span style={{ width:"5px",
                height:"5px",
                display:"flex",
                alignItems:"top",
                opacity:"0.8",
                display:"inline-block",
                borderRadius: "50%",
                backgroundColor:"#6b6b6b" ,
                position:"relative",
                top:"-2px",
                marginRight: "5px"}}></span>Communication providers to enable communication between Users</p>
            </li>
        </ul>
        <p  className="extraspace" style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent:"0",textAlign: "justify"}}>We may also share personal information with law enforcement or government agencies in response to a valid legal request.</p>
        <h4  className="extraheading1" style={{paddingTop: "8pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "left",color:" rgb(65, 137, 221)",fontWeight:"600",fontSize:"20px",fontFamily:'Poppins'}}>Cookies</h4>
        <p  className="extraspace"  style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify",lineHeight:"3rem"}} >We use cookies and similar technologies to enhance User experience on our Platform. Cookies are small data files that are placed on your device. They may be used to store your preferences or track your activity on our Platform. You may opt-out of cookies by adjusting your browser settings.</p>
        <h4  className="extraheading1"  style={{paddingTop: "8pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify",color:" rgb(65, 137, 221)",fontWeight:"600",fontSize:"20px",fontFamily:"Poppins"}}>Data Retention</h4>
        <p  className="extraspace" style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify"}}>We retain personal information for as long as necessary to provide our Platform and fulfill our legal obligations. We will securely delete personal information when it is no longer needed.</p>
        <h4  className="extraheading1" style={{paddingTop: "8pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "left",color:" rgb(65, 137, 221)",fontWeight:"600",fontSize:"20px",fontFamily:"Poppins"}}>Security</h4>
        <p  className="extraspace"  style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent:"0pt",textAlign: "justify",lineHeight:"3rem"}}>We take appropriate measures to protect personal information against unauthorized access, alteration, or destruction. We restrict access to personal information to employees and contractors who need to know the information to provide our services.</p>
        <h4  className="extraheading1"  style={{paddingTop: "8pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "left",color:" rgb(65, 137, 221)",fontWeight:"600",fontFamily:"Poppins",fontSize:"20px"}}>Your Rights</h4>
        <p  className="extraspace"   style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent:"0pt",textAlign: "justify"}}>You have the right to access, correct, or delete your personal information. You may also request that we restrict the processing of your personal information or transfer it to another party. To exercise these rights, please contact us using the contact information below.</p>
        <h4  className="extraheading1"  style={{paddingTop: "7pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "left",color:" rgb(65, 137, 221)",fontWeight:"600",fontSize:"20px",fontFamily:"Poppins"}}>Children&#39;s Privacy</h4>
        <p  className="extraspace" style={{paddingTop: "9pt",paddingLeft: "5pt",textIndent:"0pt",textAlign: "justify"}}>Our Platform is not intended for use by children under the age of 18. We do not knowingly collect personal information from children under 18. If you become aware that a child under 18 has provided us with personal information, please contact us using the contact information below.</p>
        <h4  className="extraheading1" style={{paddingTop: "8pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "left",color:" rgb(65, 137, 221)",fontWeight:"600",fontSize:"20px",fontFamily:"Poppins"}}>Changes to this Policy</h4>
        <p  className="extraspace" style={{paddingTop: "4pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "justify"}}>We may update this Policy from time to time to reflect changes in our privacy practices. We will notify Users of any material changes to this Policy by email or through our Platform.</p>
        <p  className="extraspace"  style={{paddingTop: "7pt",paddingLeft: "5pt",textIndent: "0pt",textAlign: "left"}}>
            <a href="http://wareeg.io/"  style={{color: "#374151", fontFamily:"&quot;Segoe UI&quot;, sans-serif", fontStyle: "normal", fontWeight: "normal", textDecoration: "none", fontSize: "12pt"}} target="_blank" className="extraspace">Contact Us If you have any questions or concerns about this Policy, please contact us at </a>
            <a href="http://wareeg.io/" target="_blank" style={{color:'#4189DD'}}  className="extraspace" >wareeg.io.</a>
        </p>
        </>
    )
}
export default PrivacyPol;